var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseManagePasswordComponent } from '@app/components/_shared/account/base-manage-password/base-manage-password.component';
import { LoadingProvider } from '@app/components/_shared/loading-spinner/loading-spinner.component';
import { UserModel } from '@app/models/user/user.model';
import { AuthService } from '@app/services/auth.service';
import { LocalisationService } from '@app/services/localisation.service';
import { UserService } from '@app/services/user.service';
import * as _ from 'lodash';
import { AppConfig } from '../../../app.config';
import { equalsValidator } from '../../../directives/equals-validator.directive';
import { Globals } from './../../../../globals';
var AccountSettingsComponent = /** @class */ (function (_super) {
    __extends(AccountSettingsComponent, _super);
    function AccountSettingsComponent(globals, route, router, localisation, authService, formBuilder, userService, loading) {
        var _this = _super.call(this, globals, route, router, localisation, authService, formBuilder) || this;
        _this.userService = userService;
        _this.loading = loading;
        // BaseManagePasswordComponent template variables to be passed
        _this.templateSettings = {
            headerLegend: true,
            showMessagesBottom: true,
            redirectOnSuccess: false
        };
        _this.locale = {};
        // to disable the settings
        _this.isDaraUser = false;
        _this.profileForm = new FormGroup({});
        _this.profileFormSubmitted = false;
        _this.passwordForm = new FormGroup({});
        _this.passwordFormSubmitted = false;
        _this.countryOptions = [];
        _this.displayLanguageOptions = [];
        _this.formSubmitted = false;
        _this.languageChanged = false;
        return _this;
    }
    AccountSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.locale = this.localisation.getTranslationsForComponent('AccountSettingsComponent');
        this.loading.show(this.locale.findingYourSettings, true);
        this.passwordLength = AppConfig.passwordLength;
        if (sessionStorage.getItem('completed') === 'true') {
            sessionStorage.removeItem('completed');
            location.reload();
        }
        this.userService
            .getCountries()
            .subscribe(function (countries) {
            return (_this.countryOptions = _.orderBy(countries, ['priority', 'countryName'], 'asc'));
        });
        this.userService.getGenders().subscribe(function (genders) { return (_this.genderOptions = genders); });
        this.userService
            .getDisplayLanguages()
            .subscribe(function (languages) { return (_this.displayLanguageOptions = languages); });
        this.profileForm = this.formBuilder.group({
            firstName: [null, Validators.required],
            secondName: [null, Validators.required],
            email: [null, [Validators.required, Validators.pattern(AppConfig.emailRegex)]],
            gender: [null, Validators.required],
            school: [null],
            displayLanguage: [null, Validators.required],
            emailPreference: [true, Validators.required],
            country: [null, [Validators.required]]
        });
        this.passwordForm = this.formBuilder.group({
            currentPassword: [null, [Validators.required]],
            newPassword: [null, [Validators.required, Validators.minLength(this.passwordLength)]],
            confirmPassword: [null, [Validators.required, Validators.minLength(this.passwordLength)]]
        }, {
            validator: equalsValidator('newPassword', 'confirmPassword')
        });
        this.userService.getUser().subscribe(function (user) {
            if (user.daraUserId) {
                _this.isDaraUser = true;
            }
            var formModel = new UserModel();
            formModel.firstName = user.firstName;
            formModel.secondName = user.secondName;
            formModel.email = user.email;
            formModel.gender = user.gender;
            formModel.country = user.country;
            formModel.school = user.school;
            formModel.displayLanguage = user.displayLanguage;
            formModel.emailPreference = user.emailPreference;
            _this.profileForm.setValue(formModel);
        }, function (err) { }, function () {
            _this.loading.hide();
        });
    };
    AccountSettingsComponent.prototype.updateLanguageChanged = function () {
        this.languageChanged = true;
    };
    AccountSettingsComponent.prototype.setFormSubmitted = function (value) {
        this.formSubmitted = value;
    };
    AccountSettingsComponent.prototype.onClickProfileInput = function () {
        this.messageCopyProfile = null;
    };
    AccountSettingsComponent.prototype.onClickPasswordInput = function () {
        this.messageCopyPassword = null;
    };
    AccountSettingsComponent.prototype.goBack = function () {
        window.history.back();
    };
    AccountSettingsComponent.prototype.submitProfileForm = function () {
        var _this = this;
        this.profileFormSubmitted = true;
        if (this.profileForm.valid) {
            var values = this.profileForm.value;
            this.setFormSubmitted(true);
            this.userService.updateUser(values).subscribe(function (result) {
                _this.messageClassProfile = _this.globals.styles.alertBottomClass;
                if (_this.languageChanged == true) {
                    _this.localisation
                        .updateCurrentLanguage(_this.profileForm.value.displayLanguage)
                        .then(function (data) {
                        _this.languageChanged = false;
                        _this.locale = _this.localisation.getTranslationsForComponent('AccountSettingsComponent');
                        _this.messageCopyProfile = _this.locale.profileSuccessModalMessage;
                        _this.child.callLocale();
                    });
                }
                else {
                    _this.messageCopyProfile = _this.locale.profileSuccessModalMessage;
                }
            }, function (error) { }, function () {
                _this.setFormSubmitted(false);
            });
        }
        else {
            this.messageClassProfile = this.globals.styles.errorClass;
            this.messageCopyProfile = this.locale.errorModalMessage;
            this.passwordFormSubmitted = false;
        }
    };
    AccountSettingsComponent.prototype.submitPasswordForm = function () {
        var _this = this;
        this.passwordFormSubmitted = true;
        if (!this.passwordForm.valid)
            return;
        var form = this.passwordForm.value;
        var model = new UserModel();
        model.currentPassword = form.currentPassword;
        model.password = form.newPassword;
        this.setFormSubmitted(true);
        this.userService.updateUser(model).subscribe(function (result) {
            _this.messageClassPassword = _this.globals.styles.alertBottomClass;
            _this.messageCopyPassword = _this.locale.passwordSuccessModalMessage;
            _this.passwordForm.reset();
        }, function (err) {
            var errorDetails = err.json();
            _this.messageClassPassword = _this.globals.styles.errorClass;
            // Popup diabled, so check see to if httpinterceptor returns errors if NOT revert to default message
            if (errorDetails.returnCode.hasOwnProperty('errors')) {
                _this.messageCopyPassword =
                    errorDetails.returnCode.errors[Object.keys(errorDetails.returnCode.errors)[0]];
            }
            else if (errorDetails.returnCode.hasOwnProperty('message')) {
                _this.messageCopyPassword = errorDetails.returnCode.message;
            }
            else {
                _this.messageCopyPassword = _this.locale.errorModalMessage;
            }
        }, function () {
            _this.passwordFormSubmitted = false;
            _this.setFormSubmitted(false);
        });
    };
    AccountSettingsComponent.route = 'account/settings';
    return AccountSettingsComponent;
}(BaseManagePasswordComponent));
export { AccountSettingsComponent };



// WEBPACK FOOTER //
// ./src/app/components/account/settings/account-settings.component.ts.pre-build-optimizer.js